import { createStore, pageInitialData } from '../../utils';
import { BookStoreProps } from './PageContext.types';
import { BookActions } from './bookStoreActions';

const bookStore = createStore<BookStoreProps>(pageInitialData, BookActions);

export { bookStore };
